import React from "react";
import PropTypes from "prop-types";
import { usePageContext } from "../../context";
import { FUNCTIONS_PATH } from "../../const/const";
import { FluidSections } from "../FluidSections";
import { TimedContent } from "../../components/TimedContent";

const TimedContentConnector = ({ data }) => {
	const { lang } = usePageContext();

	return (
		<TimedContent
			data={data}
			settings={{
				currentStartAt: data.activeContent?.startAt,
				currentEndAt: data.activeContent?.endAt,
				currentContent: data.activeContent?.components,
				placeholderContent: data.placeHolder,
				contentTimeList: data.contentTimeList,
			}}
			fetchContentAsync={async () =>
				fetch(
					`${
						process.env.GATSBY_FUNCTIONS_BASE_URL || ""
					}${FUNCTIONS_PATH}/timed-promo?lang=${lang}&id=${data.id}`
				)
					.then(res => res.json())
					.then(res => res.data)
			}
			renderContent={content => <FluidSections data={content} useWrapper={true} />}
		/>
	);
};

TimedContentConnector.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string,
		activeContent: PropTypes.shape({
			startAt: PropTypes.string,
			endAt: PropTypes.string,
			components: PropTypes.arrayOf(PropTypes.object),
		}),
		contentTimeList: PropTypes.arrayOf(
			PropTypes.shape({
				startAt: PropTypes.string,
				endAt: PropTypes.string,
			})
		),
		placeHolder: PropTypes.arrayOf(PropTypes.object),
	}).isRequired,
};

export { TimedContentConnector };
